import React from 'react';

const pipelineSteps = [
  { key: "pending", label: "REÇUE" },
  { key: "preparing", label: "EN PRÉPARATION" },
  { key: "ready", label: "PRÊTE" },
  { key: "dispatched", label: "EXPÉDIÉE" },
  { key: "delivered", label: "LIVRÉE" }
];

const OrderPipeline = ({ order, onAdvance, lifecycleKey }) => {
  const isCancelled = lifecycleKey === 'cancelled';
  const isError = lifecycleKey === 'payment_error';
  const isWaiting = lifecycleKey === 'waiting_restock';
  
  if (isCancelled) {
    return (
      <div className="order-pipeline">
        <div className="order-pipeline-step cancelled active" style={{ backgroundColor: "#f8d7da", color: "#842029" }}>ANNULÉE</div>
      </div>
    );
  }

  if (isError) {
    return (
      <div className="order-pipeline">
        <div className="order-pipeline-step cancelled active" style={{ backgroundColor: "#f8d7da", color: "#842029" }}>ERREUR DE PAIEMENT</div>
      </div>
    );
  }

  if (isWaiting) {
    return (
      <div className="order-pipeline">
        <div className="order-pipeline-step cancelled active" style={{ backgroundColor: "#fff3cd", color: "#664d03" }}>ATTENTE DE RÉAPPROVISIONNEMENT</div>
      </div>
    );
  }

  // Adjust labels based on mode
  const steps = [...pipelineSteps];
  if (order.orderMode === 'takeaway') {
    steps[3].label = "REMISE";
  }

  const activeIndex = steps.findIndex(s => s.key === lifecycleKey);
  const currentIdx = activeIndex === -1 && lifecycleKey === 'paid' ? 0 : activeIndex; // 'paid' treats 'pending' as active or next to preparing
  
  return (
    <div className="order-pipeline">
      {steps.map((step, idx) => {
        let statusClass = "";
        // If current
        if (lifecycleKey === step.key || (lifecycleKey === 'paid' && step.key === 'pending')) {
           statusClass = "active " + (step.key === 'delivered' ? 'delivered-step' : 'current-step');
        } else if (idx < currentIdx || (lifecycleKey === 'paid' && idx === 0)) {
           statusClass = "completed";
        }
        
        return (
          <div key={step.key} className={`order-pipeline-step ${statusClass}`}>
             {step.label}
             {(statusClass.includes('active') || statusClass.includes('completed')) && step.key === 'pending' && (
                <div className="step-date">{(order.date || "").slice(0,10)}</div>
             )}
          </div>
        );
      })}
    </div>
  );
};

export default OrderPipeline;
